import React from "react";
import "./GlobalStyles.scss";

export class GlobalStyles extends React.Component {
  public render() {
    return null;
  }
}
